import { ReactNode } from "react";
import Loader from "./Loader";

const Button = ({
	action,
	cssClass,
	children,
	isLoading,
	buttonType,
	variant = "primary",
}: {
	action?: any;
	cssClass?: string;
	children?: ReactNode;
	isLoading?: boolean;
	buttonType?: "button" | "submit" | "reset" | undefined;
	variant?: "primary" | "secondary";
}) => {
	const variantClassNames = {
		primary:
			"bg-black text-white focus:bg-white hover:bg-white focus:text-black hover:text-black",
		secondary:
			"bg-white text-black focus:bg-black hover:bg-black focus:text-white hover:text-white",
	};

	const classNamesButton = `flex gap-4 px-8 py-3 ${
		isLoading ? "pr-2" : ""
	} text-sm uppercase font-semibold rounded-sm border border-black ${
		variantClassNames[variant]
	} ${cssClass ? cssClass : ""}`;
	const classNamesNone = `${cssClass ? cssClass : ""}`;

	return (
		<button
			onClick={(event) => {
				if (action) {
					event.preventDefault();
					action();
				}
			}}
			className={
				"button" === buttonType || "submit" === buttonType
					? classNamesButton
					: classNamesNone
			}
			type={buttonType}
		>
			{children}
			{isLoading && <Loader colorCircle="#999" colorRotator="#fff" />}
		</button>
	);
};
export default Button;
